import { render, staticRenderFns } from "./trev-number-ticker.vue?vue&type=template&id=6dc0ead7&"
import script from "./trev-number-ticker.vue?vue&type=script&lang=js&"
export * from "./trev-number-ticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports